import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import ibm from "./assets/images/IBM_partner.png";

function Home() {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="text-center text-white bg_header mb-5"
        style={{
          background:
            "url('https://img.freepik.com/free-vector/ai-technology-microchip-background-vector-digital-transformation-concept_53876-117808.jpg?uid=R108868518&ga=GA1.1.1358864381.1725960411&semt=ais_hybrid') center/cover",
          padding: "180px 0 130px",
        }}
      >
        <h1 className="fw-bold mb-4">
          Aivio Virtual Intelligent Assistant Demo: Exploring{" "}
          <span className="primary_text">India's Budget Data</span>
        </h1>
        <h2 className="lead h2 mb-3">Ask Questions on India's Budget Data</h2>
        <p>
          Aivio allows users to query{" "}
          <span className="primary_text">India's 5 years</span> of budget data
          seamlessly.
        </p>
        {/* <Link to="/register" className="btn btn-light btn-lg fw-bold">
          Get Started
        </Link> */}

        <div className="IBMPartner mt-5">
           <img src={ibm} alt="IBM partner" className="" />
        </div>
      </div>

      {/* Services Section */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body p-4 d-flex flex-column">
                  <h3 className="card-title text-center">
                    User Access & Role-Based System
                  </h3>
                  <ul className="ps-0 ul_list mt-4 text-center">
                    <li>
                      <strong>2021-2023 Budget Data:</strong> Accessible to all
                      users without registration.{" "}
                    </li>
                    <li>
                      <strong>2024-2025 Budget Data: </strong> Requires user
                      registration for access.{" "}
                    </li>
                    <li>
                      This demonstrates Aivio’s role-based access control,
                      ensuring secure and controlled information retrieval.{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body p-4 d-flex flex-column">
                  <h3 className="card-title text-center">
                    Begin Your Exploration
                  </h3>
                  <ul className="ps-0 ul_list mt-4 text-center">
                    <li>
                      <strong>Ask questions </strong> related to India's budget
                      from 2021 to 2023 without login
                    </li>
                    <li>
                      <strong>Register with your email</strong> to receive login
                      credentials.{" "}
                    </li>
                    <li>
                      <strong>Log in to access</strong> the latest 2024 and 2025
                      budget insights.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-4">
              <div className="card ">
                <div className="card-body p-4">
                  <h3 className="card-title text-center">
                    Sample Questions for Budget Analysis
                  </h3>
                  <ul className="ps-0 ul_list mt-4 text-center">
                    <li>
                      <strong>
                        Summarize the budget for 2023 in 3-4 lines.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        What were the major policy changes in 2022?
                      </strong>
                    </li>
                    <li>
                      <strong>
                        Compare the defense budget from 2021 to 2023.
                      </strong>
                    </li>
                    <li>
                      <strong>
                        What are the key sectors receiving the highest
                        allocation in 2024?
                      </strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-4">
              <div className="card ">
                <div className="card-body p-4">
                  <h3 className="card-title text-center">
                    Enhancing Responses
                  </h3>
                  <p className="mb-0 text-center mt-4">
                    {" "}
                    You can <strong>refine answers</strong> by modifying the{" "}
                    <strong>task-specific prompt</strong> to match specific
                    needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-5">
              <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      What Aivio Can Do?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <h2 className="mb-4">
                        Aivio is a versatile AI-powered Virtual Intelligent
                        Assistant capable of:
                      </h2>
                      <h4>Training on Any Document Type</h4>
                      <ul>
                        <li>
                          Works with{" "}
                          <strong>Excel, PDFs, PPTs, Word, Images,</strong> and
                          more.
                        </li>
                        <li>
                          Extracts structured data for{" "}
                          <strong>fast and relevant answers.</strong>
                        </li>
                      </ul>
                      <h4>Web Scraping for Domain Knowledge</h4>
                      <ul>
                        <li>
                          Can <strong>scrape websites</strong> and use them as a{" "}
                          <strong>knowledge base.</strong>
                        </li>
                        <li>
                          Provides up-to-date insights on{" "}
                          <strong>industry-specific topics.</strong>
                        </li>
                      </ul>
                      <h4>Database Integration for Real-Time Data</h4>
                      <ul>
                        <li>
                          Connects to databases to fetch{" "}
                          <strong>real-time information</strong>
                        </li>
                        <li>
                          Enables businesses to{" "}
                          <strong>query live datasets</strong> efficiently.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      Showcasing Role-Based Access & AI Power
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <h3>With Aivio, users experience:</h3>
                      <ul>
                        <li>
                          <strong>Controlled access</strong> to premium
                          datasets.
                        </li>
                        <li>
                          <strong>Smart retrieval</strong> of relevant
                          information using AI.
                        </li>
                        <li>
                          <strong>
                            Integration with databases & web sources
                          </strong>{" "}
                          for up-to-date responses.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center mb-5">
                <h2 className="secondary_text">
                  Try Aivio today and explore India's budget like never before!
                  🚀
                </h2>
                 <Link to="/know-your-cost" className="btn custom-btn mt-3 btn-11">Know Your Cost For Aivio</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
